import { Css_BodyText, HeadingH2 } from '@dreamstack/feature-components'
import { useTranslation } from '@dreamstack/i18n'
import { SimpleTextLink } from '@dreamstack/simple-components'
import type { FunctionComponent } from 'react'
import 'twin.macro'
import { useSearchContext } from '../SearchContext'
import { useSearchHits } from '../SearchHitsContext'

export const NewsSearchResultBox: FunctionComponent<React.PropsWithChildren<{}>> = () => {
  const context = useSearchContext()
  const hits = useSearchHits()
  const t = useTranslation()
  if (!context) return null
  const { searchState, resetState } = context
  const query = searchState?.query
  const noOfResults = hits?.length || 0
  return (
    <>
      <div tw="flex-1">
        <HeadingH2>
          {t('accentro:newsSearch.yourSearchFor')} &quot;{query}
          &quot;
        </HeadingH2>
        <div css={Css_BodyText}>
          <span tw="text-accentroGray-full">
            {noOfResults} {t('accentro:newsSearch.noOfResultsSuffix')} ·{' '}
          </span>
          <SimpleTextLink onClick={() => resetState()} tw="font-semibold">
            {t('accentro:newsSearch.resetAction')}
          </SimpleTextLink>
        </div>
      </div>
    </>
  )
}
